import Carousel from 'modules/common/components/Carousel/Carousel';

export default Carousel;
